module.exports = __webpack_public_path__ + "ea6f6bb53e40fc050402902da0982ac0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/book-s.png
// module id = 1806
// module chunks = 0